import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { HashLink } from 'react-router-hash-link';
import MenuButton from './MenuButton';
import { DiCssdeck } from 'react-icons/di';
import { FaGithub, FaLinkedin, FaEnvelopeSquare } from 'react-icons/fa';

function Mobile() {
	const [isOpen, setIsOpen] = useState(false);

	const clickHandler = () => {
		setIsOpen(!isOpen);
	};

	const listsVariants = {
		visible: {
			x: isOpen ? 0 : '-100vw',
			display: isOpen ? 'flex' : 'none',
			transition: {
				duration: 0.5,
			},
		},
	};

	return (
		<nav className="w-11/12 m-auto flex flex-col justify-center items-center">
			<div className="w-full h-fit py-6 flex justify-between items-center">
				<div className="flex flex-row justify-between items-center text-blue text-2xl font-semibold cursor-text">
					<DiCssdeck />
					<span className="italic">Judith</span>
				</div>
				<div>
					<MenuButton isOpen={isOpen} clickHandler={clickHandler} />
				</div>
			</div>
			<motion.ul
				variants={listsVariants}
				animate="visible"
				className="flex flex-col justify-center items-center mt-7 gap-7"
			>
				{[
					['About', '/#about'],
					['Projects', '/projects'],
					['Technologies', '/#techs'],
					['Resume', '/#resume'],
				].map(([list, url], index) => (
					<li key={index} className="text-base font-normal">
						<HashLink
							scroll={(element) =>
								element.scrollIntoView({ behavior: 'smooth' })
							}
							to={url}
							className="text-light-gray hover:text-blue no-underline"
						>
							{list}
						</HashLink>
					</li>
				))}
			</motion.ul>
			<motion.div
				variants={listsVariants}
				animate="visible"
				className="w-fit flex justify-between items-center gap-7 my-7"
			>
				<a href="https://github.com/mmajudith" target="blank">
					<FaGithub className="w-7 h-7 hover:text-blue" />
				</a>
				<a
					href="https://www.linkedin.com/in/judith-onyekwelu-b96655205"
					target="blank"
				>
					<FaLinkedin className="w-7 h-7 hover:text-blue" />
				</a>
				<a href="mailto:judithonyekwelu01@gmail.com">
					<FaEnvelopeSquare className="w-7 h-7 hover:text-blue" />
				</a>
			</motion.div>
		</nav>
	);
}

export default Mobile;
